import ExploreContentWrapper from '../explorecontentwrapper/ExploreContentWrapper';
import ExploreSearchSidebar from '../exploresearchsidebar/ExploreSearchSidebar';
import Modal from '@core/components/Modal/Modal';

import UseModal from 'hooks/use-modal';

import { Sort, Filter, TickSquare } from 'iconsax-react';

import { MOBILE_SLIDE_UP } from '@core/constants/ModalTypes';
import { orderingValues } from 'constants/search-sort.const';

import classes from './ExploreMobileSortFilter.module.scss';

const ExploreMobileSortFilter = ({
	filters,
	searchKeyword,
	selectedCategories,
	selectedContent,
	selectedOrdering,
	selectedPrice,
	selectedProficiency,
	selectedHighlighted,
	selectedCareerPath,
	handleCategoryClick,
	handlePriceClick,
	handleProficiencyClick,
	handleQueryKeywordChange,
	handleContentTypeSelect,
	handleOrderingChange,
	handleHighlightedChange,
	handleCareerPathChange,
}) => {
	const {
		destroyModal: destroySortModal,
		show: showSortModal,
		showModal: handleShowSortModal
	} = UseModal();
	const {
		destroyModal: destroyFilterModal,
		show: showFilterModal,
		showModal: handleShowFilterModal
	} = UseModal();

	const handleClickOrder = (newOrder) => {
		handleOrderingChange(newOrder);
		destroySortModal();
	};

	return (
		<>
			<div className="container d-flex flex-row justify-items-start mb-4">
				<ExploreContentWrapper
					selectedContent={selectedContent}
					handleContentTypeSelect={handleContentTypeSelect}
					selectedOrdering={selectedOrdering}
					handleOrderingChange={handleOrderingChange}
				/>
			</div>
			<div className={`${classes['explore-mobile-sort-filter']} w-100`}>
				<div className="container">
					<div className={`${classes['explore-mobile-sort-filter-actions']}`}>
						<button onClick={handleShowSortModal}>
							<Sort size={18} color="#000000" variant="TwoTone" /> Sort
						</button>
						<button onClick={handleShowFilterModal}>
							<Filter size={18} color="#000000" variant="TwoTone" /> Filter
						</button>
					</div>
				</div>
			</div>
			<Modal
				type={MOBILE_SLIDE_UP}
				title="Filters"
				show={showFilterModal}
				closeHandler={destroyFilterModal}>
				<div style={{ minWidth: '50vw' }}>
					<ExploreSearchSidebar
						filters={filters}
						searchKeyword={searchKeyword}
						selectedCategories={selectedCategories}
						selectedPrice={selectedPrice}
						selectedProficiency={selectedProficiency}
						selectedHighlighted={selectedHighlighted}
						selectedCareerPath={selectedCareerPath}
						handleCategoryClick={handleCategoryClick}
						handlePriceClick={handlePriceClick}
						handleProficiencyClick={handleProficiencyClick}
						handleQueryKeywordChange={handleQueryKeywordChange}
						handleHighlightedChange={handleHighlightedChange}
						handleCareerPathChange={handleCareerPathChange}
					/>
				</div>
			</Modal>
			<Modal
				type={MOBILE_SLIDE_UP}
				title="Sort By:"
				show={showSortModal}
				closeHandler={destroySortModal}>
				<div
					className={`${classes['explore-mobile-sort-modal']} d-flex flex-column`}
					style={{ minWidth: '50vw' }}>
					{orderingValues.map((orderVal) => {
						return (
							<button key={orderVal.value} onClick={() => handleClickOrder(orderVal.value)}>
								{selectedOrdering === orderVal.value && (
									<TickSquare color="#bb3a90" style={{ marginRight: '8px' }} />
								)}
								{orderVal.name}
							</button>
						);
					})}
				</div>
			</Modal>
		</>
	);
};

export default ExploreMobileSortFilter;
